var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_container1"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"body_container"},[(_vm.toggle)?_c('div',{staticClass:"sidebar_container",class:_vm.smallScreen ? 'sidebar_mobile' : ''},[_c('Sidebar')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"route_view_container"},[_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed06bbc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 